// Verifierade kundomdömen — sanningskälla för Review- och AggregateRating-schema
// samt den synliga omdömessektionen.
//
// REGEL: en post får bara läggas till när omdömet faktiskt är lämnat av kunden
// och vi kan visa det publikt. Google kräver att betyg som märks upp också syns
// på sidan, och påhittade omdömen är både policybrott och förtroendebrott.
// Tom lista = inget Review-/AggregateRating-schema emitteras alls.

export interface CustomerReview {
  /** Personens namn så som det får publiceras. */
  author: string;
  /** Roll och företag, t.ex. "Marknadschef, Garageportexperten". */
  role: string;
  /** Omdömet i kundens egna ord. */
  body: string;
  /** Betyg 1–5. Utelämna om kunden inte satt betyg. */
  rating?: number;
  /** ISO-datum när omdömet lämnades. */
  date: string;
  /** Var omdömet lämnades, t.ex. "Google Business Profile". */
  source?: string;
  /** Publik URL till omdömet, om det finns. */
  sourceUrl?: string;
  /** Vilket tjänsteområde omdömet gäller — styr var det visas. */
  area?: "film" | "foto" | "pulse" | "prime";
}

export const CUSTOMER_REVIEWS: CustomerReview[] = [];

/** Omdömen med satt betyg — underlag för AggregateRating. */
export const RATED_REVIEWS = CUSTOMER_REVIEWS.filter(
  (r) => typeof r.rating === "number" && r.rating >= 1 && r.rating <= 5,
);

/**
 * AggregateRating räknas fram från faktiska betyg. Returnerar undefined
 * när underlaget saknas eller är för tunt (< 3 omdömen) — ett snittbetyg
 * på ett enda omdöme är ingen trovärdig signal.
 */
export const aggregateRatingValue = () => {
  if (RATED_REVIEWS.length < 3) return undefined;
  const sum = RATED_REVIEWS.reduce((acc, r) => acc + (r.rating ?? 0), 0);
  return {
    value: Math.round((sum / RATED_REVIEWS.length) * 10) / 10,
    count: RATED_REVIEWS.length,
  };
};
